export default __webpack_public_path__ + "static/google_Desktop2-cb23ee0f48f0b3e742c729ec858ddcb6.svg";